import { DocumentData } from "firebase/firestore";
import moment from "moment";
import { toast } from "react-toastify";
import { createGradient } from "../../../utils";
import parse from "html-react-parser";

export function EventDetailScreen({
  event,
  handleNextSteps,
}: {
  event: DocumentData;
  handleNextSteps: () => void;
}) {
  const handleBuyTickets = () => {
    if (event?.soldOut) return toast.error("Event is sold out");
    handleNextSteps();
  };

  const themeStyle = event?.style;

  const actionButtons = ({ className }: { className: string }) => {
    const buttonStyle = themeStyle
      ? {
          background: themeStyle?.buttonColor,
          color: themeStyle?.buttonTextColor,
        }
      : {};
    return (
      <>
        <button
          className={className}
          disabled={event?.soldOut}
          onClick={handleBuyTickets}
          style={buttonStyle}
        >
          {event?.soldOut ? "SOLD OUT" : "Buy Tickets"}
        </button>
        {(event?.extraCtas ?? []).map(
          (el: { url: string; text: string }, key: number) => (
            <button
              className={className}
              key={key}
              style={buttonStyle}
              onClick={() => window.open(el.url, "_blank", "noreferrer")}
            >
              {el?.text}
            </button>
          )
        )}
      </>
    );
  };

  return (
    <div
      className='landing-container'
      style={{
        background: themeStyle?.backgroundColours
          ? createGradient(themeStyle.backgroundColours)
          : "#fff",
        color: themeStyle?.mainTextColor,
      }}
    >
      <div className='event-details-container'>
        <div className='event-details-left-container'>
          <div className='event-details-left-container-img'>
            <img src={event?.picture} alt='event-pic' className='img-fluid' />
          </div>
          {actionButtons({ className: "btn btn-primary" })}
        </div>
        <div />
        <div className='event-details-right-container'>
          <h2 style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}>
            {event?.title}
          </h2>
          <div className='event-details-right-container_info-flex'>
            <div className='event-details-right-container_info-flex-icon'>
              <i className='bi bi-calendar'></i>
            </div>
            <div className='event-details-right-container_info-flex-text'>
              <h5 style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}>
                {moment.unix(event?.date?.seconds).format("dddd, MMMM Do YYYY")}
              </h5>
              <p style={{ color: themeStyle?.mainTextColor ?? "#5c5c5c" }}>
                {moment.unix(event?.date?.seconds).format("h:mm A")}
              </p>
            </div>
          </div>
          <div className='event-details-right-container_info-flex'>
            <div className='event-details-right-container_info-flex-icon'>
              <i className='bi bi-geo'></i>
            </div>
            <div className='event-details-right-container_info-flex-text'>
              <h5 style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}>
                {event?.venue || "Location not available"}
              </h5>
            </div>
          </div>
          {actionButtons({ className: "btn btn-primary event-tickets-btn" })}
          <div className='event-details-right-container_about-us'>
            <h4 style={{ color: themeStyle?.mainTextColor ?? "#a0a7b4" }}>
              About Event
            </h4>
            {parse(event?.about)}
            {/* <Markdown>{event?.about}</Markdown> */}
          </div>
          <div className='event-details-right-container_about-us'>
            <h4 style={{ color: themeStyle?.mainTextColor ?? "#a0a7b4" }}>
              Contact Us
            </h4>
            <div className='socials'>
              {event?.website ? (
                <a
                  href={event?.website}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}
                >
                  <i className='bi bi-globe'></i>
                </a>
              ) : null}
              {event?.social?.instagram ? (
                <a
                  href={event?.social?.instagram}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}
                >
                  <i className='bi bi-instagram'></i>
                </a>
              ) : null}
              {event?.social?.linkedin ? (
                <a
                  href={event?.social?.linkedin}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}
                >
                  <i className='bi bi-linkedin'></i>
                </a>
              ) : null}
              {event?.social?.x ? (
                <a
                  href={event?.social?.x}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}
                >
                  <i className='bi bi-twitter-x'></i>
                </a>
              ) : null}
              {event?.social?.facebook ? (
                <a
                  href={event?.social?.facebook}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}
                >
                  <i className='bi bi-facebook'></i>
                </a>
              ) : null}
              {event?.social?.tiktok ? (
                <a
                  href={event?.social?.tiktok}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: themeStyle?.mainTextColor ?? "#1d1d1d" }}
                >
                  <i className='bi bi-tiktok'></i>
                </a>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
